import React, { useState } from "react";
import "cropperjs/dist/cropper.min.css";
import { Box } from "@mui/material";
import styles from "./style.module.css";
import ImageCropper from "./cropper";
import { uploadImage } from "../../../../../../../helpers/uploadImageToS3";
import imageCompression from "browser-image-compression";
import { useDispatch, useSelector } from "react-redux";
import {
  setCroppedImage,
  setIsModalProjectOpen,
  setOriginalProjectImage,
  setSelectedProjectImage,
} from "../../../../../../../store/slices/profile/projectCoverImageSlice";

const EditProjectImage = ({ project }) => {
  const dispatch = useDispatch();
  const { selectedProjectImage } = useSelector(
    (state) => state.projectCoverImage
  );

  const [isProjectUploading, setIsProjectUploading] = useState(false);

  const handleCrop = async (croppedImage) => {
    try {
      const blob = new Blob([croppedImage], { type: "image/png" });
      const originalBlob = blob;

      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 800,
        useWebWorker: true,
        quality: 1,
      };

      const compressedBlob = await imageCompression(originalBlob, options);

      const blobURL = await uploadImage(
        compressedBlob,
        "project-cover-image-" + Math.random() + "-v-" + new Date().getTime()
      );

      dispatch(setCroppedImage(blobURL));

      // handle original image uploade
      if (selectedProjectImage !== project?.original_cover_image) {
        const response = await fetch(selectedProjectImage);
        const blobData = await response.blob();

        // Compress the image using browser-image-compression library
        const options = {
          maxSizeMB: 1, // Set the maximum size of the compressed image
          maxWidthOrHeight: 800, // Set the maximum width or height of the compressed image
          useWebWorker: true, // Use a web worker for faster compression
          quality: 1,
        };

        const compressedBlob = await imageCompression(blobData, options);

        const originalImageUrl = await uploadImage(
          compressedBlob,
          "original-image-project-" + project.id + "-v-" + new Date().getTime()
        );

        dispatch(setOriginalProjectImage(originalImageUrl));
        dispatch(setSelectedProjectImage(originalImageUrl));
      } else {
        dispatch(setOriginalProjectImage(project.original_cover_image));
      }

      dispatch(setSelectedProjectImage(null));
      dispatch(setIsModalProjectOpen(false));
    } catch (error) {
      console.error("Error handling upload:", error);
    }
  };

  const handleCancel = () => {
    dispatch(setSelectedProjectImage(null));
    dispatch(setIsModalProjectOpen(false));
  };

  return (
    <Box className={styles.parent}>
      <Box className={styles.container}>
        <ImageCropper
          imageSrc={selectedProjectImage}
          onCrop={handleCrop}
          onCancel={handleCancel}
          isProfileUploading={isProjectUploading}
          setIsProfileUploading={setIsProjectUploading}
        />
      </Box>
    </Box>
  );
};

export default EditProjectImage;
